import { CONFIG_PAGES, ICONS_WEB } from "@miplatform/constants";

export const CONFIG_ROUTE_ICONS = {
  [CONFIG_PAGES.MI_SCHEDULING]: ICONS_WEB.CALENDAR_BLANK_OUTLINE,
  [CONFIG_PAGES.MI_DISPATCH]: ICONS_WEB.HEADSET,
  [CONFIG_PAGES.MI_INSPECTIONS]: ICONS_WEB.CLIPBOARD_SEARCH_OUTLINE,
  [CONFIG_PAGES.MI_ACCOUNTING]: ICONS_WEB.CURRENCY,
  [CONFIG_PAGES.MI_ESTIMATING]: ICONS_WEB.FLOOR_PLAN,
  [CONFIG_PAGES.HR]: ICONS_WEB.ACCOUNT_GROUP,
  [CONFIG_PAGES.ALERTS]: ICONS_WEB.ALERT_OUTLINE,
  [CONFIG_PAGES.SETTINGS]: ICONS_WEB.COG,
  [CONFIG_PAGES.OPERATIONS]: ICONS_WEB.CITY,
  [CONFIG_PAGES.AUTO]: ICONS_WEB.CHART_SANKEY_VARIANT,
};
